// =================

import React, { useState, useContext, ReactNode, useRef, useEffect } from 'react';
import styles from './styles.module.scss';
import ToolbarIcons from '@/icons/toolbar';
// import { LayoutContext } from '@/context/LayoutContext';

interface HelpBoxProps {
  children?: ReactNode;
  width?: number | string;
}

interface LayoutContextType {
  dir: 'ltr' | 'rtl';
}

const HelpBox: React.FC<HelpBoxProps> = ({ children, width = 16 }) => {
  const [openInfoBox, setOpenInfoBox] = useState<boolean>(false);

  const containerRef = useRef<HTMLDivElement>(null);

  // Close when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
        setOpenInfoBox(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className={styles.container} ref={containerRef}>
      <ToolbarIcons.helpIcon
        onClick={() => setOpenInfoBox(!openInfoBox)}
        width={`${width}`}
        height={`${width}`}
        className="cursor-pointer"
      />

      {openInfoBox && <div className={`${styles.absoluteBox} `}>{children}</div>}
    </div>
  );
};

export default HelpBox;
